<template>
  <svg
    width="19"
    height="17"
    viewBox="0 0 19 17"
  >
    <path d="M10.7045 1.28401C10.3111 0.896393 9.67798 0.901082 9.29036 1.29449C8.90274 1.68789 8.90743 2.32104 9.30083 2.70866L14.6712 8.00006H1C0.447715 8.00006 0 8.44778 0 9.00006C0 9.55235 0.447716 10.0001 1 10.0001H14.6646L9.30083 15.2849C8.90743 15.6726 8.90274 16.3057 9.29036 16.6991C9.67798 17.0925 10.3111 17.0972 10.7045 16.7096L17.6287 9.88721C18.1256 9.3976 18.1256 8.59601 17.6287 8.1064L10.7045 1.28401Z" />
  </svg>
</template>
